// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { inventoryController } from "../../../game_theme/flow_fb/flowController";
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentContainer } from "../../framework/components/ComponentContainer";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { DialogSettings, PowerUpSettings } from "../../settings/Settings";
import { AngryAnalytics } from "../Analytics/Analytics";
import { s_black_square, s_popup_darkblue_rect, s_popup_top, s_popup_close, s_icon_close, s_popup_bottom, s_popup_add_homescreen_content, s_btn_green } from "../AssetDefinitions/ImageDefinitions";
import { EventSystem } from "../Events/EventSystem";
import { Events } from "../Events/Events";
import { PowerupRewardDialog } from "./PowerupRewardDialog";
import { tgfHooks } from "../../framework/hooks/hooks";
tgfSettings.dialogDefaults.CreateShortcutDialog = {
    width: 800,
    height: 500,
    font: DialogSettings.textFont,
    smallFont: DialogSettings.textFontSmall,
    buttonFont: DialogSettings.buttonFont,
    components: [] // The additional components to add
};
export var CreateShortcutDialog = function (properties) {
    "use strict";
    this.name = "CreateShortcutDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.CreateShortcutDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
    this.onDisconnect = this.close.bind(this, false);
    EventSystem.subscribe(Events.DISCONNECTED, this.onDisconnect);
};
// Inherit the base dialog
tgfDialogs.inherit(CreateShortcutDialog, DialogBase);
CreateShortcutDialog.prototype.doPrepare = function () {
    "use strict";
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2),
        y: -(this.height / 2)
    });
    this.transparentBlack.addComponent(this.background);
    this.headerBackground = new ComponentPicture({
        image: s_popup_top,
        x: tgfGraphics.areaWidth / 2,
        y: -this.height / 2 + tgfGraphics.areaHeight / 2
    });
    this.addComponent(this.headerBackground);
    this.closeButton = new ComponentButton({
        image: s_popup_close,
        icon: s_icon_close,
        x: this.width / 2 + 5,
        y: 33,
        onClick: this._onDecline.bind(this),
    });
    this.headerBackground.addComponent(this.closeButton);
    this.addComponent(new ComponentPicture({
        image: s_popup_bottom,
        x: tgfGraphics.areaWidth / 2,
        y: this.height / 2 - 20 + tgfGraphics.areaHeight / 2
    }));
    this.headerLabel = new ComponentLabel({
        text: tgfDictionary.getText("HOMESCREEN_POPUP_HEADER"),
        font: this.font,
        y: 4
    });
    this.headerBackground.addComponent(this.headerLabel);
    this.centerLabel = new ComponentLabel({
        text: tgfDictionary.getText("HOMESCREEN_BODY_1_TEXT"),
        font: this.font,
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - 160,
        splitLines: true,
        width: this.width - 20,
    });
    this.addComponent(this.centerLabel);
    this.centerImage = new ComponentPicture({
        image: s_popup_add_homescreen_content,
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 - 30,
    });
    this.addComponent(this.centerImage);
    this.leftLabel = new ComponentLabel({
        text: tgfDictionary.getText("HOMESCREEN_BODY_3_TEXT"),
        font: this.smallFont,
        x: tgfGraphics.areaWidth / 2 - 123,
        y: tgfGraphics.areaHeight / 2 + 63,
    });
    this.addComponent(this.leftLabel);
    this.rightLabel = new ComponentLabel({
        text: tgfDictionary.getText("HOMESCREEN_BODY_2_TEXT"),
        font: this.smallFont,
        x: tgfGraphics.areaWidth / 2 + 121,
        y: tgfGraphics.areaHeight / 2 + 63,
    });
    this.addComponent(this.rightLabel);
    this.buttonContainer = new ComponentContainer({
        x: tgfGraphics.areaWidth / 2,
        y: tgfGraphics.areaHeight / 2 + 150
    });
    this.addComponent(this.buttonContainer);
    this.acceptButton = new ComponentButton({
        image: s_btn_green,
        text: tgfDictionary.getText("BTN_HOMESCREEN_POPUP"),
        fontUp: this.buttonFont,
        onClick: this._onAccept.bind(this),
    });
    this.buttonContainer.addComponent(this.acceptButton);
    AngryAnalytics.reportScreen("shortcut");
};
CreateShortcutDialog.prototype.close = function () {
    this.hide();
    this.free();
    EventSystem.unsubscribe(Events.DISCONNECTED, this.onDisconnect);
    if (this.onClose) {
        this.onClose();
    }
};
CreateShortcutDialog.prototype._onAccept = function () {
    var self = this;
    var onCloseReward = this.onClose;
    tgfHooks.createHomeScreenButton().then(function () {
        var rewardScreen = new PowerupRewardDialog({
            onClose: onCloseReward,
            reverseAnimation: inventoryController.getFilledPowerUps() == PowerUpSettings.maxSlotAmount
        });
        rewardScreen.show();
        inventoryController.unlockAllPowerUps([0, 0, 0]);
        rewardScreen.reloadPowerups(true);
        console.log("Successfully created a shortcut");
    }).catch(function (e) {
        if (e && e["code"] === "USER_INPUT") {
            onCloseReward();
            return;
        }
        var rewardScreen = new PowerupRewardDialog({
            onClose: onCloseReward,
            reverseAnimation: inventoryController.getFilledPowerUps() == PowerUpSettings.maxSlotAmount
        });
        rewardScreen.show();
        inventoryController.unlockAllPowerUps([0, 0, 0]);
        rewardScreen.reloadPowerups(true);
        console.log("failed to create a shortcut with reason: " + e);
    }).catch(function (e) {
        console.error(e);
    });
    this.onClose = null;
    this.close();
};
CreateShortcutDialog.prototype._onDecline = function () {
    this.close();
};
CreateShortcutDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
